const toDate = (str: string, isEnd = false) => {
  const [
    d,
    m,
    y,
    h = isEnd ? 23 : 0,
    min = isEnd ? 59 : 0,
    s = isEnd ? 59 : 0,
  ]: Array<any> = str.split(/[- :]/);
  return new Date(y, m - 1, d, h, min, s);
};

export const isDateBetween = (
  dateStr: string,
  startStr: string,
  endStr: string
) => {
  if (endStr === "") {
    return dateStr.includes(startStr);
  } else {
    const date = toDate(dateStr);
    return date >= toDate(startStr) && date <= toDate(endStr, true);
  }
};
